import { makeStyles } from '@material-ui/core';
import variables from './variables';

export const useCommonStyles = makeStyles(() => ({
  tableHeader: {
    fontSize: 14,
    '& .MuiTableCell-head': {
      alignContent: 'baseline',
      borderBottom: 'none',
      fontWeight: 400,
    },
    '& .MuiTableCell-sizeSmall': {
      color: `${variables.black50} !important;`,
      textTransform: 'capitalize !important;',
    },
  },
  tableRow: {
    borderCollapse: 'separate',
    fontSize: 14,
    '& .MuiTableCell-sizeSmall': {
      padding: '6px 16px',
      color: variables.richBlack,
    },

    '& .MuiTableCell-body': {
      padding: '6px 16px',
      color: variables.richBlack,
    },

    '&:hover': {
      backgroundColor: variables.ghostWhite,
    },
  },
  btnCell: {
    padding: '6px 0px !important;',
  },
  buttonContained: {
    padding: '10px 20px',
    textTransform: 'none',
    width: '100%',
  },
  collapsibleRow: {
    fontSize: 14,
    '& .MuiTableCell-sizeSmall': {
      padding: '6px 16px',
      color: variables.richBlack,
    },

    '&:hover': {
      backgroundColor: variables.ghostWhite,
    },
    '& > *': {
      borderBottom: 'unset',
    },
  },
  mainContainer: {
    gap: 16,
    paddingBottom: 32,
    marginTop: 119,

    '@media (max-width: 1180px)': {
      marginTop: 0,
    },
  },
  formControlTitle: {
    color: '#030C2180',
    display: 'block',
    fontWeight: 400,
    fontSize: 12,
    textAlign: 'start',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  formControl: {
    width: '100%',
  },
  optionSelector: {
    color: '#030C21',

    '&.MuiListItem-root.Mui-selected': {
      color: '#030C2180',
      backgroundColor: variables.white,
    },

    '@media (max-width: 1180px)': {
      fontSize: 12,
      padding: '0 8px',
    },
  },
  header: {
    height: 81,
    minHeight: 56,
    gap: 16,
    paddingTop: 16,
    paddingBottom: 16,
    fontWeight: 600,
    fontSize: 18,
    textAlign: 'start',
    color: variables.richBlack,
  },
  activeDialogBtn: {
    backgroundColor: `${variables.mediumSeaGreen} !important;`,
    color: `${variables.white} !important;`,
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    border: 'none !important;',
    height: 56,

    '&:hover': {
      backgroundColor: `${variables.mediumSeaGreen} !important;`,
    },

    '& path': {
      stroke: `${variables.white} !important;`,
    },

    '&.Mui-disabled': {
      color: `${variables.black20} !important;`,
      backgroundColor: `${variables.black10} !important;`,
    },
  },
  negativeDialogBtn: {
    backgroundColor: `${variables.americanPink} !important;`,
    color: `${variables.white} !important;`,
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    border: 'none !important;',
    height: 56,

    '&:hover': {
      backgroundColor: `${variables.americanPink} !important;`,
    },

    '& path': {
      stroke: `${variables.white} !important;`,
    },
  },
  cancelDialogBtn: {
    height: 56,
    color: `${variables.black} !important;`,
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    border: 'none !important;',
    marginLeft: '0px !important;',
    marginTop: 10,

    '&:hover': {
      backgroundColor: `${variables.white} !important;`,
      color: `${variables.black50} !important;`,
    },
  },
  tabs: {
    backgroundColor: `${variables.black10} !important;`,
    borderRadius: '8px !important;',
    boxShadow: 'none !important;',
    color: `${variables.richBlack} !important;`,

    '& .MuiTab-root': {
      padding: 0,
      border: `none !important`,
    },

    '& .MuiTab-wrapper': {
      textTransform: 'none',
      padding: 9,
      fontWeight: 700,
      fontSize: 12,
    },

    '& .Mui-selected': {
      backgroundColor: `${variables.white} !important;`,
      textTransform: 'none',
      borderRadius: 8,
      margin: 3,
    },

    '& .MuiTabs-indicator': {
      color: variables.fossilGrey,
      height: 0,
    },
  },
  switchRoot: {
    padding: '4px !important;',
    '& .MuiSwitch-track': {
      background: variables.white,
      border: '1px solid #919191',
      borderRadius: 60,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        width: 50,
        height: 30,
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track:before': {
      color: variables.white,
    },
    '& .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track:after': {
      color: variables.fossilGrey,
    },
    '& .MuiSwitch-switchBase': {
      color: variables.chineseWhite,
      paddingTop: 7,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      '& .MuiSwitch-thumb': {
        background: variables.white,
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      opacity: 1,
      background: '#3BBB7A',
      border: `1px solid #3BBB7A`,
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 24,
      height: 24,
    },
  },
  contentWithAccordion: {
    '& .Mui-expanded': {
      margin: '0px !important',
      backgroundColor: '#FAFAFA',
    },
  },
  accordion: {
    minHeight: '88px !important;',
    boxShadow: 'none !important;',
    borderRadius: '16px !important;',
    padding: 16,
    marginBottom: '8px !important',
    '&&&:before': {
      background: 'transparent',
    },
    '& .MuiAccordionSummary-root': {
      padding: 0,
    },

    '& .MuiAccordionSummary-expandIcon': {
      color: variables.richBlack,
      marginRight: 'unset !important',
      marginInlineEnd: '-12px !important',
    },

    '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
      color: variables.black50,
      marginInlineEnd: '-12px !important',
    },
    '& .MuiAccordionDetails-root': {
      padding: '6px 0px !important;',
    },
    '&:last-child': {
      marginBottom: '0px !important',
    },
  },
  accordionContent: {
    margin: '0px !important',
    padding: 0,
    backgroundColor: variables.white,
    alignItems: 'center',
  },
  accordionHeader: {
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    lineHeight: '19px !important;',
    textAlign: 'start',
    color: variables.richBlack,
    marginBottom: '8px !important',
  },
  accordionSubHeader: {
    textAlign: 'start',
    'font-weight': '400 !important;',
    fontSize: '16px !important;',
    color: variables.black50,
    lineHeight: '19px !important;',
  },
  editBtn: {
    gap: 16,
    paddingLeft: 16,
    paddingRight: 16,
    border: 'none',
    height: 56,
    color: `${variables.richBlack} !important;`,
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    marginInlineEnd: 10,

    '& .MuiButton-startIcon': {
      marginInlineStart: 0,
      marginInlineEnd: 16,
    },
    '& .MuiButton-endIcon': {
      marginInlineStart: 8,
      marginInlineEnd: '-4px',
    },

    '&:hover': {
      color: variables.black50,
      backgroundColor: 'unset',

      '& path': {
        stroke: variables.black50,
      },
    },
  },
  deleteBtn: {
    border: 'none',
    height: 56,
    color: `${variables.desire} !important;`,
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    marginInlineEnd: 10,

    '&:hover': {
      color: variables.americanPink,
      backgroundColor: 'unset',

      '& path': {
        stroke: variables.americanPink,
      },
    },
  },
  dialogHeader: {
    margin: 0,
    paddingLeft: 3,
    paddingRight: 0,
    gap: 16,
    paddingTop: 16,
    paddingBottom: 16,
    color: variables.black,
  },
  dialogCloseBtn: {
    color: variables.black,
  },
  dialogContent: {
    padding: 16,
  },
  dialogAction: {
    flexDirection: 'column',
    paddingLeft: 0,
    paddingRight: 0,
  },
  dialogTitle: {
    'font-weight': '600 !important;',
    fontSize: '16px !important;',
    textAlign: 'center',
    color: variables.richBlack,
  },
  dialogBody: {
    fontWeight: 400,
    fontSize: '16px !important;',
    textAlign: 'center',
    color: variables.black50,
  },
  tableCustomPaging: {
    color: variables.black50,
  },
  showMoreRowsBtn: {
    color: variables.richBlack,
    fontWeight: 600,
    fontSize: 16,
    border: 'none',
    height: 56,
    '&:hover': {
      color: variables.black50,
      backgroundColor: 'unset',
    },
  },
  runReportBtn: {
    height: 48,
    borderRadius: 8,
    padding: '0 16px',
    whiteSpace: 'nowrap',
    backgroundColor: `${variables.mediumSeaGreen} !important;`,
    color: `${variables.white} !important;`,
    fontWeight: 600,
    fontSize: '16px !important;',
    border: 'none !important;',

    '&:hover': {
      backgroundColor: `${variables.mediumSeaGreen} !important;`,
    },

    '& path': {
      stroke: `${variables.white} !important;`,
    },
  },
}));
